export const GET_CARDS_QUERY_PARAMS_KEYS = {
  EMPLOYEE_ID: 'employee_id',
  DEPENDENT_ID: 'dependent_id',
};
export const ROOT_DEPENDENT_ID = 'none';
